module.exports = __webpack_public_path__ + "img/shop_mobile.9c189f13.png";